export const createReferralSlice = (set) => ({
    hasShared: false,
    setHasShared: (value) => {
        set({ hasShared: value });
    },
});
